import { motion } from "framer-motion";

const banners = [
  { src: "/banner1.png", alt: "banner 1" },
  { src: "/banner2.png", alt: "banner 2" },
  { src: "/banner3.png", alt: "banner 3" },
  { src: "/banner4.png", alt: "banner 4" },
  { src: "/banner5.png", alt: "banner 5" },
];

export default function BannerSection() {
  return (
    <section id="banner" className="relative w-full py-20 md:py-32 bg-warm-950">
      <div className="max-w-[1000px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
            CAMPAIGN
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-50">
            今夜、最高のコスパで最高の夜を。
          </h2>
        </motion.div>
        <div className="flex flex-col items-center gap-4">
          {banners.map((banner, i) => (
            <motion.img
              key={i}
              src={banner.src}
              alt={banner.alt}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="w-full object-cover rounded-xl"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
